/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable guard-for-in */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-control-statements/jsx-use-if-tag */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-useless-escape */
/* eslint-disable complexity */
/* eslint-disable */
import React, { useState } from 'react'

import { Button, Radio } from '@cleartrip/bento'

import { isEmpty } from 'AccountsUtils'
import OfflineToast from '../offlineToast'
import { SVGComponent } from '../..'
import { sendOtpForSignIn } from '../../../pages/Trips/trips.helper'

import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'

import { errorConfig } from './errorConfig'

const transformEmail = email => {
  console.log(email)
  const [userName, domain] = email.split('@')
  let censoredUsername = ''
  if (userName.length > 5) {
    censoredUsername =
      userName[0] +
      userName[1] +
      '*'.repeat(userName.length - 4) +
      userName.slice(-2)
  } else {
    switch (userName.length) {
      case 1:
        censoredUsername = '*'
        break
      case 2:
        censoredUsername = `${userName[0]}*`
        break
      case 3:
        censoredUsername = `${userName[0]}*${userName[2]}`
        break
      case 4:
        censoredUsername = userName[0] + '*'.repeat(2) + userName[3]
        break
      case 5:
        censoredUsername = userName[0] + '*'.repeat(3) + userName[4]
        break
    }
  }
  return `${censoredUsername}@${domain}`
}

const EmailsLinkedML = ({
  mobileNumber,
  defaultCountryCode,
  linkedEmails,
  email,
  setEmail,
  setPageName,
  userDetail,
  setIsEmailLinked = () => {}
}) => {
  const [apiError, setApiError] = useState('')

  const [loading, setLoading] = useState(false)

  const errorInfo = 'fs-inherit c-inherit pl-2'
  const [isSelected, setIsSelected] = useState(false)
  function renderEmails() {
    return linkedEmails.map(emailObj => {
      const { userName } = emailObj || {}
      return (
        <div className="mb-5">
          <Radio
            checked={userName === email}
            name="email"
            onClick={() => {
              setApiError('')
              if (userName === email) {
                setEmail('')
              } else {
                setEmail(userName)
              }
              setIsSelected(true)
            }}
          >
            <span className="fs-3 c-neutral-700 ml-2">
              {transformEmail(userName)}
            </span>
          </Radio>
        </div>
      )
    })
  }

  const sendOtp = async () => {
    setLoading(true)
    const payload = {
      type: 'EMAIL',
      value: email,
      action: 'UPDATE_EMAIL'
    }
    try {
      const res = await sendOtpForSignIn(payload)
      const { status, data, error } = res || {}
      if (status == 202) {
        setIsEmailLinked(true)
        setPageName(USER_PROFILE_PAGE_CONTANTS.VERIFY_EMAILML)
      } else {
        const { response = { data: {} } } = error || {}
        const { data = {} } = response
        const { message } = data
        const err = errorConfig[message] || errorConfig.default
        setApiError(err)
      }
    } catch (e) {
      setApiError('Something went wrong!')
      console.error(e)
    }

    setLoading(false)
  }

  const noEmailSelectedHandler = async () => {
    setEmail('')
    setPageName('SIGNIN_EMAILML')
  }
  return (
    <div
      className="bg-white br-4 br-4 o-hidden d-flex flex-column"
      style={{
        width: '600px',
        height: '468px'
      }}
    >
      <div className=" d-flex flex-1 flex-column">
        <span className="fs-4 fw-600">
          Mobile number already linked with email account(s)
        </span>

        <OfflineToast page="verify email address" />

        <div className="mt-5 d-flex flex-column flex-1">
          <div>
            <span className="fs-3 fw-500 ">
              Select your preferred email account to merge with{' '}
            </span>
            <span className="fs-3 fw-500">{` ${defaultCountryCode} ${
              userDetail.mobile
            } `}</span>
            <div className="mt-6 oy-scroll " style={{ maxHeight: '200px' }}>
              {renderEmails()}
            </div>
            {isSelected ? (
              <span className="fs-14 fw-500" style={{ color: '#DF9641' }}>
                Note : Merge action cannot be reverted.
              </span>
            ) : (
              <div />
            )}
          </div>
          {apiError && (
            <>
              <div
                className="fw-500 fs-12 lh-16 mt-2"
                style={{ color: '#CC1414' }}
              >
                {apiError}
              </div>
            </>
          )}

          <div className="mt-5 mb-8 flex flex-row">
            <div className="mb-4">
              <Button
                size="md"
                type="secondary"
                full={false}
                busy={loading}
                disabled={isEmpty(email)}
                onClick={sendOtp}
              >
                <span className="fs-3 fw-550">Verify selected email</span>
              </Button>
            </div>
            <div
              className="ta-center fs-14 fw-600 c-blue c-pointer mt-2 ml-7"
              onClick={noEmailSelectedHandler}
            >
              None of these are mine
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmailsLinkedML
